import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import {
  getGallery,
  type GalleryRequest,
  type GalleryResponse,
} from "@/services/api/gallery";

export const galleryKeys = {
  all: ["gallery"] as const,
  lists: () => [...galleryKeys.all, "list"] as const,
  list: (categoryId: string | number, request: GalleryRequest) =>
    [...galleryKeys.lists(), categoryId, request] as const,
};

export function useGallery(
  categoryId: string | number,
  request: GalleryRequest,
  options?: Omit<
    UseQueryOptions<GalleryResponse, Error>,
    "queryKey" | "queryFn"
  >
) {
  return useQuery<GalleryResponse, Error>({
    queryKey: galleryKeys.list(categoryId, request),
    queryFn: () => getGallery(categoryId, request),
    enabled: !!categoryId,
    ...options,
  });
}

